import { InjectionToken } from '@angular/core';

export let CHECK_DUPLICATED_REGISTRATIONS = new InjectionToken<boolean>(
    'CHECK_DUPLICATED_REGISTRATIONS',
);
export let PROPOSE_ALTERNATE_COMMUNITIES = new InjectionToken<boolean>(
    'PROPOSE_ALTERNATE_COMMUNITIES',
);
export let SHOW_LOCATION_SELECTORS = new InjectionToken<boolean>(
    'SHOW_LOCATION_SELECTORS',
);
